import { useDispatch, useSelector } from "react-redux";

import JobsCompWrapper from "../../StylesWrappers/postJobsWrappers/allPostJobsCards";
import JobPostCard from "./others/jobPostCard";
import { AppDispatch, RootState } from "../../store";
import { ConfirmationModal } from "../General/helpers";
import { setCloseConfirmationModal } from "../../features/general/generalSlice";
import Overlay from "../General/overlay";
import Loader from "../General/Loader";

interface EngringJobsCompProps {
  handleJobDetails: (_id: string) => void;
  initialSaveForLater?: any;
  handleSaveForLater?: (_id: string) => void;
}

const EngringJobsComp = ({
  handleJobDetails,
  initialSaveForLater,
  handleSaveForLater,
}: EngringJobsCompProps) => {
  const { engineeringPostJobs, postJobsLoading } = useSelector(
    (store: RootState) => store.allPostJobsStore
  );
  const { openConfirmationModal } = useSelector(
    (store: RootState) => store.generalStore
  );

  const dispatch = useDispatch<AppDispatch>();

  return (
    <>
      {postJobsLoading && (
        <Overlay>
          <Loader />
        </Overlay>
      )}
      <ConfirmationModal
        handleCloseModal={() => dispatch(setCloseConfirmationModal())}
        handleRemoveItem={handleSaveForLater}
        isOverlayModal={openConfirmationModal}
        modalMessage="Are you sure you want to save this job for later"
      />
      <JobsCompWrapper>
        {engineeringPostJobs.map((each) => {
          const {
            _id,
            position,
            company,
            jobType,
            jobLocation,
            jobEmail,
            jobUrl,
          }: any = each;
          return (
            <JobPostCard
              key={_id}
              handleJobDetails={() => handleJobDetails(_id)}
              initialSaveForLater={() => initialSaveForLater(_id)}
              position={position}
              company={company}
              jobType={jobType}
              jobLocation={jobLocation}
              jobEmail={jobEmail}
              jobUrl={jobUrl}
            />
          );
        })}
      </JobsCompWrapper>
    </>
  );
};

export default EngringJobsComp;
